<div *routerOuter class="row">
  <div class="col col-120 col-lg-100 col-xl-80" *ngIf="item">
    <form-group-context label="ID">
      <span>{{ item.id }}</span>
    </form-group-context>

    <form-group-context label="Created At">
      <span>{{ item.createdAt | moment }}</span>
    </form-group-context>

    <form-group-context label="Updated At">
      <span>{{ item.updatedAt | moment }}</span>
    </form-group-context>

    <form-group-context label="Account">
      <entity-link type="account" [item]="item" [name]="item.email" [showLink]="false"></entity-link>
      <p *ngIf="item.meta">
        {{ item.meta | json}}
      </p>
    </form-group-context>


    <form-group-context label="Provider">
      <span>{{ item.OAuthProvider }}</span><br>
      <span class="text-muted">{{ item.OAuthId }}</span>
    </form-group-context>

    <form-group-context label="Confirm">
      <badge-exist existText="Verified" existColor="success" [item]="item.verified"></badge-exist>
    </form-group-context>
  </div>
</div>
